
<p-confirmDialog />

<div class="page-container">
  <div class="card card-timesheet">
    <div class="card-content">
      <!-- Stats cards (same pattern as Allocation/Forecast) -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ getFormattedGrandTotal() }}</span>
          <span class="stats-card-label">Total Hours</span>
          <span class="stats-card-sublabel">{{ getMonthName() }} {{ selectedYear }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-clock"></i></div>
      </div>
      <div class="stats-card stats-card--fully-allocated">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ timesheetRows.length }}</span>
          <span class="stats-card-label">Entries</span>
          <span class="stats-card-sublabel">This month</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ timesheetStatsProjectCount }}</span>
          <span class="stats-card-label">Projects</span>
          <span class="stats-card-sublabel">With entries</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
      <div class="stats-card" [class.stats-card--fully-allocated]="currentTimesheet?.isSubmitted" [class.stats-card--warning]="!currentTimesheet?.isSubmitted">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ currentTimesheet?.isSubmitted ? 'Submitted' : 'Draft' }}</span>
          <span class="stats-card-label">Status</span>
          <span class="stats-card-sublabel">{{ currentTimesheet ? 'Work log status' : 'No work log yet' }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi" [class.pi-check-circle]="currentTimesheet?.isSubmitted" [class.pi-pencil]="!currentTimesheet?.isSubmitted"></i></div>
      </div>
    </div>
      <!-- Page header: title + lock when submitted; right = all actions on same line -->
      <div class="page-header">
        <div class="page-header-left">
          <div class="page-header-title-row">
            <h2 class="page-header-title">{{ isViewingAnotherEmployee ? 'View Work Log' : 'My Work Log' }}</h2>
            <i *ngIf="currentTimesheet?.isSubmitted"
               class="pi pi-lock timesheet-status-lock"
               pTooltip="This work log is submitted. You cannot edit or add entries for this month."
               tooltipPosition="bottom"
               aria-hidden="true"></i>
          </div>
          <p class="page-header-subtitle">{{ currentEmployeeName }}</p>
          <!-- Block next month until previous month is submitted -->
          <div *ngIf="previousMonthHasDraft" class="submitted-warning-banner previous-month-banner">
            <i class="pi pi-info-circle"></i>
            <span>Submit your {{ previousMonthDraftLabel }} work log before adding or saving {{ getMonthName() }} {{ selectedYear }}.</span>
          </div>
        </div>
        <div class="page-header-actions page-header-actions-right timesheet-header-actions-same-line page-header-actions-buttons">
          <p-button
            *ngIf="!currentTimesheet?.isSubmitted"
            label="Add Entries"
            icon="pi pi-plus"
            (onClick)="addRow()"
            [disabled]="isReadOnly || loading || previousMonthHasDraft"
            severity="primary" />
          <p-button
            label="View Calendar"
            icon="pi pi-calendar"
            (onClick)="openCalendarDialog()"
            [disabled]="loading"
            severity="secondary"
            styleClass="btn-copy-action" />
          <p-button
            label="Export Excel"
            icon="pi pi-file-excel"
            (onClick)="exportTimesheetToExcel()"
            [disabled]="loading || timesheetRows.length === 0"
            severity="success"
            styleClass="btn-export-excel" />
          <p-button
            label="Work Log Summary"
            icon="pi pi-chart-bar"
            (onClick)="openProjectSummaryDialog()"
            [disabled]="loading || timesheetRows.length === 0"
            severity="secondary"
            styleClass="btn-copy-action" />
          <p-button
            icon="pi pi-question-circle"
            label="User Guide"
            (onClick)="showUserGuide = true"
            severity="secondary"
            styleClass="btn-copy-action"
            pTooltip="View Work Log User Guide" />
          <p-button
            *ngIf="hasInlineEdits"
            label="Save"
            icon="pi pi-save"
            (onClick)="saveTimesheet()"
            [disabled]="loading || saving || isReadOnly || previousMonthHasDraft || (timesheetRows.length === 0 && !currentTimesheet)"
            severity="success"
            pTooltip="Save your entries. Status stays Draft until you click Submit." />
          <p-button
            *ngIf="!currentTimesheet?.isSubmitted"
            label="Submit All Work Logs"
            icon="pi pi-check-circle"
            (onClick)="submitTimesheet()"
            [disabled]="loading || !canSubmit || saving || isReadOnly"
            severity="danger"
            pTooltip="Submit locks this month; you cannot edit after submitting." />
          <p-button
            *ngIf="canShowReopenButton"
            label="Reopen"
            icon="pi pi-unlock"
            (onClick)="reopenTimesheet()"
            [disabled]="loading || saving"
            severity="warn" />
        </div>
      </div>

    

    <!-- ── Work Log filter bar ── -->
    <div *ngIf="!loading" class="filter-bar filter-bar-no-shadow wl-filter-bar">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Project Name</label>
          <input
            pInputText
            [(ngModel)]="filterProject"
            placeholder="Search project…" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Type of Work</label>
          <input
            pInputText
            [(ngModel)]="filterTaskType"
            placeholder="Search task…" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Description</label>
          <input
            pInputText
            [(ngModel)]="filterDescription"
            placeholder="Search description…" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Date</label>
          <p-datepicker
            [(ngModel)]="filterDate"
            placeholder="Pick a date"
            [showIcon]="true"
            [showClear]="true"
            dateFormat="M d, yy"
            [defaultDate]="timesheetMinDate"
            [minDate]="timesheetMinDate"
            [maxDate]="timesheetMaxDate"
            appendTo="body"
            [showOnFocus]="false" />
        </div>
      </div>
      <div class="filter-bar-actions">
        <span *ngIf="hasActiveSearchFilters" class="wl-filter-count">
          {{ filteredTimesheetRows.length }}&nbsp;/&nbsp;{{ timesheetRows.length }}
        </span>
        <button
          *ngIf="hasActiveSearchFilters"
          type="button"
          class="btn-clear-filters"
          (click)="clearSearchFilters()"
          title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <div class="timesheet-grid" *ngIf="!loading">
      <p-table
        [value]="filteredTimesheetRows"
        styleClass="p-datatable-gridlines timesheet-grid-table"
        [tableStyle]="{ 'min-width': '100%' }"
        [sortMode]="'multiple'"
        [paginator]="false"
        [scrollable]="true"
        scrollHeight="flex"
      >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col class="col-add-btn" style="width: 52px; min-width: 52px;">
          <col style="width: 24%">
          <col style="width: 19%">
          <col [style]="isReadOnly ? 'width: 32%' : 'width: 20%'">
          <col class="col-date" style="width: 12%">
          <col class="col-hours" style="width: 13%">
          <col *ngIf="!isReadOnly" class="col-actions" style="width: 80px; min-width: 80px;">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="th-number-column">
            <p-button
              *ngIf="!isReadOnly"
              type="button"
              icon="pi pi-plus"
              (onClick)="onAddRowInlineClick($event)"
              [disabled]="isReadOnly || loading || previousMonthHasDraft"
              severity="success"
              [rounded]="true"
              size="small"
              pTooltip="Add New Entry"
              tooltipPosition="right"
              styleClass="table-header-add-btn" />
          </th>
          <th [pSortableColumn]="'projectName'">
            Project
            <p-sortIcon field="projectName"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'taskName'">
            Type of Task
            <p-sortIcon field="taskName"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'description'">
            Description
            <p-sortIcon field="description"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'date'">
            Date
            <p-sortIcon field="date"></p-sortIcon>
          </th>
          <th>Hours / Minutes</th>
          <th *ngIf="!isReadOnly" class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr [class.editing-row]="row.isEditing">
          <td class="td-number-column">{{ rowIndex + 1 }}</td>
          
          <!-- Project Column -->
          <td class="project-cell">
              <p-select
                [(ngModel)]="row.projectId"
                (ngModelChange)="onProjectSelected(row.projectId, row); row.isEditing = true"
                (onBlur)="fieldTouched['row_' + rowIndex + '_projectId'] = true"
                [options]="assignedProjects"
                optionLabel="name"
                optionValue="id"
                [placeholder]="row.projectName || 'Select project'"
                [filter]="true"
                [showClear]="false"
                [disabled]="isReadOnly"
              [style]="{'width': '100%', 'min-width': '180px'}"
              styleClass="inline-select"
              [class.ng-invalid-field]="fieldTouched['row_' + rowIndex + '_projectId'] && !row.projectId"
              appendTo="body"
              [panelStyle]="{'min-width': '250px', 'z-index': '10000'}" />
              <small class="field-error" *ngIf="fieldTouched['row_' + rowIndex + '_projectId'] && !row.projectId">Required</small>
          </td>
          
          <!-- Task Column -->
          <td class="task-cell">
              <p-select
                [(ngModel)]="row.taskId"
                (ngModelChange)="onTaskSelected(row.taskId, row); row.isEditing = true"
                (onBlur)="fieldTouched['row_' + rowIndex + '_taskId'] = true"
                [options]="getTaskOptionsForRow(row)"
                optionLabel="name"
                optionValue="id"
                [placeholder]="row.taskName || 'Select task'"
                [filter]="true"
                [showClear]="false"
                [disabled]="isReadOnly"
              [style]="{'width': '100%', 'min-width': '180px'}"
              styleClass="inline-select"
              [class.ng-invalid-field]="fieldTouched['row_' + rowIndex + '_taskId'] && !row.taskId"
              appendTo="body"
              [panelStyle]="{'min-width': '250px', 'z-index': '10000'}" />
              <small class="field-error" *ngIf="fieldTouched['row_' + rowIndex + '_taskId'] && !row.taskId">Required</small>
          </td>
          
          <!-- Description Column -->
          <td class="description-cell">
            <input
              *ngIf="!isReadOnly"
              pInputText
              [(ngModel)]="row.description"
              (input)="row.isEditing = true; row.descriptionInvalid = false; markUnsavedIfExistingRow(row)"
              maxlength="500"
              placeholder="Enter description"
              class="description-input p-inputtext"
              [class.description-input--over]="row.descriptionInvalid || (row.description?.length || 0) >= 500"
              styleClass="description-input" />
            <small *ngIf="!isReadOnly && (row.description?.length || 0) >= 450"
                   class="description-counter"
                   [class.description-counter--over]="(row.description?.length || 0) >= 500">
              {{ row.description?.length || 0 }}/500
            </small>
            <span *ngIf="isReadOnly" class="description-text">{{ row.description || '-' }}</span>
          </td>
          
          <!-- Date Column -->
          <td class="date-cell">
            <p-datepicker
              *ngIf="row.entryMode === 'date'"
              [(ngModel)]="row.date"
              (ngModelChange)="onDateChange(row); row.isEditing = true"
              (onBlur)="fieldTouched['row_' + rowIndex + '_date'] = true"
              (onShow)="onDatePickerShow(row)"
              [minDate]="getTimesheetMonthMinDate()"
              [maxDate]="getTimesheetMonthMaxDate()"
              [showIcon]="true"
              [showOnFocus]="false"
              [readonlyInput]="true"
              dateFormat="mm/dd/yy"
              [disabled]="isReadOnly"
              [style]="{'width': '100%'}"
              styleClass="inline-calendar"
              [class.ng-invalid-field]="fieldTouched['row_' + rowIndex + '_date'] && !row.date"
              placeholder="Select date"
              appendTo="body" />
            <small class="field-error" *ngIf="row.entryMode === 'date' && fieldTouched['row_' + rowIndex + '_date'] && !row.date">Required</small>
            <span *ngIf="row.entryMode === 'week'">-</span>
          </td>
          
          <!-- Hours and Minutes (date mode): compact, max 24h per day -->
          <td class="hours-cell">
            <ng-container *ngIf="row.entryMode === 'date'; else weekDash">
              <div class="hm-compact" [class.ng-invalid-field]="fieldTouched['row_' + rowIndex + '_hours'] && !(row.entryHours > 0 || row.entryMinutes > 0)">
                <label class="hm-label">H</label>
                <input type="number" class="hm-input hm-hours"
                  [(ngModel)]="row.entryHours" (ngModelChange)="onRowHoursMinutesChange(row); row.isEditing = true" (input)="clampHoursInput(row, $event)" (keydown)="preventDecimalInput($event)"
                  (blur)="fieldTouched['row_' + rowIndex + '_hours'] = true"
                  min="0" max="24" step="1" maxlength="2" placeholder="0" [disabled]="isReadOnly" title="Hours (0-24)" />
                <label class="hm-label">M</label>
                <input type="number" class="hm-input hm-mins"
                  [(ngModel)]="row.entryMinutes" (ngModelChange)="onRowHoursMinutesChange(row); row.isEditing = true" (input)="clampMinutesInput(row, $event)" (keydown)="preventDecimalInput($event)"
                  (blur)="fieldTouched['row_' + rowIndex + '_hours'] = true"
                  min="0" max="59" step="1" maxlength="2" placeholder="0" [disabled]="isReadOnly" title="Minutes (0-59)" />
              </div>
              <small class="field-error" *ngIf="fieldTouched['row_' + rowIndex + '_hours'] && !(row.entryHours > 0 || row.entryMinutes > 0)">Required</small>
            </ng-container>
            <ng-template #weekDash><span>-</span></ng-template>
          </td>
          
          <!-- Actions column (per _tables.scss: table-cell-actions, table-actions-stack, table-action-btn) -->
          <td *ngIf="!isReadOnly" class="table-cell-actions action-cell">
            <div class="table-actions-stack">
              <p-button
                icon="pi pi-trash"
                (onClick)="removeRow(row)"
                [text]="true"
                severity="danger"
                size="small"
                pTooltip="Delete entry" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td [attr.colspan]="isReadOnly ? 6 : 7" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No entries yet</p>
              <p class="empty-description">Click "Add Entries" to start logging your time.</p>
            </div>
          </td>
        </tr>
      </ng-template>

      </p-table>
    </div>
    </div>
  </div>
</div>

<!-- Calendar Dialog: unique timesheet calendar popup design -->
<p-dialog
  header="Work Log Calendar - {{ getCalendarMonthName() }} {{ calendarViewYear }}"
  [(visible)]="showCalendarDialog"
  [modal]="true"
  [style]="{ width: 'auto', maxWidth: '540px', minWidth: '500px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="closeCalendarDialog()"
  styleClass="timesheet-calendar-popup"
  [contentStyle]="{ 'overflow': 'visible', 'padding': '0' }">
  
  <div class="timesheet-calendar-popup-content">
    <div class="timesheet-calendar-month-bar">
      <i class="pi pi-calendar" aria-hidden="true"></i>
      <span class="timesheet-calendar-month-title">{{ getCalendarMonthName() }} {{ calendarViewYear }}</span>
      <span class="timesheet-calendar-month-hint">Click a day to add entry</span>
    </div>
    
    <div class="timesheet-calendar-legend">
      <span class="timesheet-calendar-legend-pill legend-not-filled"><i class="pi pi-circle"></i> Not Filled</span>
      <span class="timesheet-calendar-legend-pill legend-under"><i class="pi pi-clock"></i> &lt;8h</span>
      <span class="timesheet-calendar-legend-pill legend-ok"><i class="pi pi-check"></i> ≥8h</span>
    </div>
    
    <div class="timesheet-calendar-grid">
      <div class="timesheet-calendar-weekdays">
        <span *ngFor="let dayName of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']">{{ dayName }}</span>
      </div>
      <div class="timesheet-calendar-days">
        <div class="timesheet-calendar-day empty" *ngFor="let empty of [].constructor(getFirstDayOfMonth())"></div>
        <button
          type="button"
          class="timesheet-calendar-day"
          [class.filled-red]="day.status === 'red' && !isWeekend(day.date)"
          [class.filled-amber]="day.status === 'amber' && !isWeekend(day.date)"
          [class.filled-green]="day.status === 'green' && !isWeekend(day.date)"
          [class.weekend]="isWeekend(day.date)"
          (click)="addEntryForDate(day)"
          *ngFor="let day of calendarDays"
          [attr.aria-label]="'Add entry for ' + day.day + ' ' + getCalendarMonthName()">
          <span class="day-num">{{ day.day }}</span>
          <span class="day-hrs" *ngIf="day.hours > 0">{{ day.hours }}h</span>
        </button>
      </div>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="closeCalendarDialog()" severity="secondary" />
  </ng-template>
</p-dialog>

<!-- Bulk Entry Dialog: form-dialog-form + unique timesheet add-entry design -->
<p-dialog
  header="Add Multiple Entries"
  [(visible)]="showBulkEntryDialog"
  [modal]="true"
  [style]="{ width: 'min(95vw, 900px)' }"
  styleClass="timesheet-add-entries-dialog"
  [dismissableMask]="true"
  [closable]="true"
  (onHide)="closeBulkEntryDialog()">

  <form #bulkForm="ngForm" (ngSubmit)="saveBulkEntries()" class="form-dialog-form form-dialog-compact timesheet-add-entries-form">
  <div class="form-dialog-container">
  
  <!-- Form header: Entry type + Date in one line -->
  <div class="timesheet-add-entries-header timesheet-form-header-one-line">
    <div class="timesheet-form-header-row">
      <div class="timesheet-header-field">
        <span class="form-section-label">Entry type</span>
        <div class="timesheet-entry-type-row">
          <label class="timesheet-entry-type-radio"><input type="radio" name="bulkLeaveType" [(ngModel)]="bulkDialogEntryMode" value="regular" (ngModelChange)="onBulkDialogEntryModeChange()" /> Regular</label>
          <label class="timesheet-entry-type-radio"><input type="radio" name="bulkLeaveType" [(ngModel)]="bulkDialogEntryMode" value="holiday" (ngModelChange)="onBulkDialogEntryModeChange()" /> Holiday</label>
          <label class="timesheet-entry-type-radio"><input type="radio" name="bulkLeaveType" [(ngModel)]="bulkDialogEntryMode" value="annualLeave" (ngModelChange)="onBulkDialogEntryModeChange()" /> Annual</label>
          <label class="timesheet-entry-type-radio"><input type="radio" name="bulkLeaveType" [(ngModel)]="bulkDialogEntryMode" value="casualLeave" (ngModelChange)="onBulkDialogEntryModeChange()" /> Casual</label>
          <label class="timesheet-entry-type-radio"><input type="radio" name="bulkLeaveType" [(ngModel)]="bulkDialogEntryMode" value="lieuLeave" (ngModelChange)="onBulkDialogEntryModeChange()" /> Lieu</label>
        </div>
      </div>
      <div class="timesheet-header-field" *ngIf="bulkDialogEntryMode === 'regular'">
        <span class="form-section-label">Date(s) *</span>
        <div class="timesheet-date-wrapper">
          <span class="bulk-dates-summary" [class.has-dates]="bulkEntrySelectedDates.length">{{ getBulkDatesSummary() }}</span>
          <p-datepicker
            [(ngModel)]="bulkEntrySelectedDates"
            [ngModelOptions]="{standalone: true}"
            selectionMode="multiple"
            [minDate]="getTimesheetMonthMinDate()"
            [maxDate]="getTimesheetMonthMaxDate()"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            dateFormat="mm/dd/yy"
            [class.ng-invalid-field]="fieldTouched['bulkDates'] && !bulkEntrySelectedDates.length"
            placeholder=""
            appendTo="body" />
          <small class="field-error" *ngIf="fieldTouched['bulkDates'] && !bulkEntrySelectedDates.length">Select at least one date</small>
        </div>
      </div>
      <div class="timesheet-header-field" *ngIf="bulkDialogEntryMode !== 'annualLeave' && bulkDialogEntryMode !== 'regular'">
        <span class="form-section-label">Date *</span>
        <p-datepicker
          [(ngModel)]="bulkEntryDate"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onBulkDateChange()"
          [minDate]="getTimesheetMonthMinDate()"
          [maxDate]="getTimesheetMonthMaxDate()"
          [showIcon]="true"
          dateFormat="mm/dd/yy"
          [class.ng-invalid-field]="fieldTouched['bulkDate'] && !bulkEntryDate"
          placeholder="Select date"
          appendTo="body" />
        <small class="field-error" *ngIf="fieldTouched['bulkDate'] && !bulkEntryDate">Required</small>
      </div>
      <div class="timesheet-header-field-group" *ngIf="bulkDialogEntryMode === 'annualLeave'">
        <div class="timesheet-header-field">
          <span class="form-section-label">Start *</span>
          <p-datepicker
            [(ngModel)]="leaveAnnualStartDate"
            [ngModelOptions]="{standalone: true}"
            [minDate]="getTimesheetMonthMinDate()"
            [maxDate]="getTimesheetMonthMaxDate()"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            placeholder="Start"
            appendTo="body" />
        </div>
        <div class="timesheet-header-field">
          <span class="form-section-label">End *</span>
          <p-datepicker
            [(ngModel)]="leaveAnnualEndDate"
            [ngModelOptions]="{standalone: true}"
            [minDate]="getTimesheetMonthMinDate()"
            [maxDate]="getTimesheetMonthMaxDate()"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            placeholder="End"
            appendTo="body" />
        </div>
      </div>
    </div>
  </div>
  
  <div class="form-section">
  <label class="form-section-label">Entries</label>
  <div class="bulk-entries-wrap">
    <div class="bulk-entries-scroll">
      <div class="bulk-entries-list">
      <div *ngFor="let entry of bulkEntries; let i = index" class="entry-section-compact">
        <div class="entry-header-row" *ngIf="bulkEntries.length > 1 && bulkDialogEntryMode === 'regular'">
          <span class="entry-title">Entry {{ i + 1 }}</span>
          <p-button icon="pi pi-trash" (onClick)="removeBulkEntryRow(i)" [text]="true" severity="danger" size="small" pTooltip="Remove" />
        </div>
        <!-- Row 1: Project | Task -->
        <div class="entry-row-2col">
          <div class="entry-col">
            <label class="bulk-label">Project *</label>
            <p-select
              [(ngModel)]="entry.projectId"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onBulkProjectChange(entry, $event)"
              [options]="assignedProjects"
              optionLabel="name"
              optionValue="id"
              placeholder="Project"
              [filter]="true"
              [showClear]="false"
              [disabled]="bulkDialogEntryMode !== 'regular'"
              styleClass="bulk-select-col"
              [class.ng-invalid-field]="fieldTouched['bulkEntries'] && !entry.projectId"
              appendTo="body"
              [panelStyle]="{'min-width': '180px', 'max-height': '240px', 'z-index': '10001'}" />
            <small class="field-error" *ngIf="fieldTouched['bulkEntries'] && !entry.projectId">Required</small>
          </div>
          <div class="entry-col">
            <label class="bulk-label">Task *</label>
            <p-select
              [(ngModel)]="entry.taskId"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onBulkTaskChange(entry, $event)"
              [options]="bulkDialogTaskOptions"
              optionLabel="name"
              optionValue="id"
              [placeholder]="bulkDialogEntryMode === 'regular' ? 'Task' : (bulkDialogTaskOptions.length ? '' : '—')"
              [filter]="bulkDialogEntryMode === 'regular'"
              [showClear]="false"
              [disabled]="bulkDialogEntryMode !== 'regular'"
              styleClass="bulk-select-col"
              [class.ng-invalid-field]="fieldTouched['bulkEntries'] && !entry.taskId"
              appendTo="body"
              [panelStyle]="{'min-width': '180px', 'max-height': '240px', 'z-index': '10001'}" />
            <small class="field-error" *ngIf="fieldTouched['bulkEntries'] && !entry.taskId">Required</small>
          </div>
        </div>
        <!-- Row 2: Description | Time (Hours + Minutes) -->
        <div class="entry-row-3col">
          <div class="entry-col entry-col-desc">
            <label class="bulk-label">Description</label>
            <input
              pInputText
              [name]="'bulkDesc_' + i"
              [(ngModel)]="entry.description"
              class="bulk-input-col"
              [placeholder]="bulkDialogEntryMode === 'holiday' ? 'e.g. Holiday name' : 'Optional'"
              [disabled]="bulkDialogEntryMode !== 'regular' && bulkDialogEntryMode !== 'holiday'" />
          </div>
          <div class="entry-col entry-col-hours">
            <label class="bulk-label">Hours (0-24)</label>
            <input type="number" class="p-inputtext bulk-input-col"
              [name]="'bulkHours_' + i"
              [(ngModel)]="entry.entryHours"
              (ngModelChange)="onBulkHoursChange(entry)"
              (input)="clampBulkHoursInput(entry, $event)"
              (keydown)="preventDecimalInput($event)"
              [class.ng-invalid-field]="fieldTouched['bulkHours'] && !(entry.entryHours > 0 || entry.entryMinutes > 0)"
              min="0" max="24" step="1" maxlength="2" placeholder="0"
              [disabled]="bulkDialogEntryMode === 'holiday' || bulkDialogEntryMode === 'annualLeave'" />
            <small class="field-error" *ngIf="fieldTouched['bulkHours'] && !(entry.entryHours > 0 || entry.entryMinutes > 0)">Required</small>
          </div>
          <div class="entry-col entry-col-minutes">
            <label class="bulk-label">Minutes (0-59)</label>
            <input type="number" class="p-inputtext bulk-input-col"
              [name]="'bulkMinutes_' + i"
              [(ngModel)]="entry.entryMinutes"
              (ngModelChange)="onBulkMinutesChange(entry)"
              (input)="clampBulkMinutesInput(entry, $event)"
              (keydown)="preventDecimalInput($event)"
              [class.ng-invalid-field]="fieldTouched['bulkHours'] && !(entry.entryHours > 0 || entry.entryMinutes > 0)"
              min="0" max="59" step="1" maxlength="2" placeholder="0"
              [disabled]="bulkDialogEntryMode === 'holiday' || bulkDialogEntryMode === 'annualLeave'" />
          </div>
        </div>
      </div>
      <!-- Add Another Entry: below entry forms, in form (not in footer) -->
      <div class="add-entry-row" *ngIf="bulkDialogEntryMode === 'regular'">
        <p-button
          type="button"
          label="Add Another Entry"
          icon="pi pi-plus"
          (onClick)="addBulkEntryRow()"
          severity="success"
          styleClass="add-entry-btn" />
      </div>
      </div>
    </div>
  </div>
  <div class="timesheet-add-entry-footer">
    <p-button
      *ngIf="bulkDialogEntryMode === 'regular'"
      type="button"
      label="Add Entry"
      icon="pi pi-plus"
      (onClick)="addBulkEntryRow()"
      severity="primary" />
  </div>
  </div>
  </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button
        type="button"
        label="Reset"
        icon="pi pi-refresh"
        (onClick)="resetBulkEntryForm()"
        severity="secondary"
        [text]="true"
        styleClass="btn-form-reset" />
      <p-button type="button" label="Cancel" icon="pi pi-times" (onClick)="closeBulkEntryDialog()" severity="secondary" [text]="true" />
      <p-button type="button" label="Add to timesheet" icon="pi pi-check" (onClick)="saveBulkEntries()" severity="primary" pTooltip="Add entry/entries to the timesheet" />
    </div>
  </ng-template>
</p-dialog>

<!-- Timesheet Summary Dialog (theme-aware for dark mode) -->
<p-dialog
  [(visible)]="showProjectSummaryDialog"
  [modal]="true"
  [closable]="true"
  styleClass="timesheet-summary-dialog"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeProjectSummaryDialog()">
  
  <ng-template pTemplate="header">
    <div class="summary-dialog-header">
      <span class="summary-dialog-title">Work Log Summary by Week</span>
      <p-button
        label="Export Excel"
        icon="pi pi-file-excel"
        (onClick)="exportSummaryToExcel()"
        severity="success"
        size="small"
        styleClass="btn-export-excel" />
    </div>
  </ng-template>
  
  <div class="summary-dialog-content">
    <p-table
      [value]="getProjectSummariesWithTotals().summaries"
      styleClass="p-datatable-gridlines summary-table"
      [tableStyle]="{ 'min-width': '100%' }"
      [paginator]="false"
      [scrollable]="true"
      scrollHeight="400px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 30%" class="text-center">Project</th>
          <th style="width: 14%" class="text-center">Week 1<br/><small>Days 1-7</small></th>
          <th style="width: 14%" class="text-center">Week 2<br/><small>Days 8-14</small></th>
          <th style="width: 14%" class="text-center">Week 3<br/><small>Days 15-21</small></th>
          <th style="width: 14%" class="text-center">Week 4<br/><small>Days 22-28</small></th>
          <th style="width: 14%" class="text-center">Week 5<br/><small>Days 29-31</small></th>
          <th style="width: 14%" class="text-center">Total</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-projectSummary>
        <tr>
          <td class="project-name-cell text-center">{{ projectSummary.projectName }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(projectSummary.weeks[0].hours) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(projectSummary.weeks[1].hours) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(projectSummary.weeks[2].hours) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(projectSummary.weeks[3].hours) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(projectSummary.weeks[4].hours) }}</td>
          <td class="text-center total-summary-cell">{{ getFormattedProjectTotal(projectSummary) }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr class="summary-total-row">
          <td class="project-name-cell text-center">TOTAL</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(getProjectSummariesWithTotals().grandTotalWeeks.week1) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(getProjectSummariesWithTotals().grandTotalWeeks.week2) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(getProjectSummariesWithTotals().grandTotalWeeks.week3) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(getProjectSummariesWithTotals().grandTotalWeeks.week4) }}</td>
          <td class="text-center week-summary-cell">{{ formatHoursMinutes(getProjectSummariesWithTotals().grandTotalWeeks.week5) }}</td>
          <td class="text-center total-summary-cell">{{ getFormattedGrandTotal() }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center">No timesheet summary available.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- ── USER GUIDE DIALOG ──────────────────────────────────────────── -->
<p-dialog
  header="Work Log User Guide"
  [(visible)]="showUserGuide"
  [modal]="true"
  [style]="{ width: 'min(95vw, 760px)' }"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  styleClass="user-guide-dialog">

  <div class="ug-body">

    <!-- Overview banner -->
    <div class="ug-banner">
      <div class="ug-banner-icon"><i class="pi pi-clock"></i></div>
      <div>
        <div class="ug-banner-title">Welcome to My Work Log</div>
        <div class="ug-banner-sub">Log your daily work hours against projects, track leave, and submit for approval — all in one place.</div>
      </div>
    </div>

    <!-- Dashboard overview -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-th-large"></i><span>Dashboard Overview</span></div>
      <div class="ug-step-desc" style="margin-bottom: var(--spacing-sm);">At the top of the page you will see four stat cards showing your month at a glance:</div>
      <!-- CSS mockup: stats cards -->
      <div class="ug-mock-stats">
        <div class="ug-mock-stat-card">
          <div class="ug-mock-stat-value">64h 30m</div>
          <div class="ug-mock-stat-label">Total Hours</div>
          <div class="ug-mock-stat-sub">March 2026</div>
          <i class="pi pi-clock ug-mock-stat-icon"></i>
        </div>
        <div class="ug-mock-stat-card">
          <div class="ug-mock-stat-value">12</div>
          <div class="ug-mock-stat-label">Entries</div>
          <div class="ug-mock-stat-sub">This month</div>
          <i class="pi pi-list ug-mock-stat-icon"></i>
        </div>
        <div class="ug-mock-stat-card">
          <div class="ug-mock-stat-value">3</div>
          <div class="ug-mock-stat-label">Projects</div>
          <div class="ug-mock-stat-sub">With entries</div>
          <i class="pi pi-briefcase ug-mock-stat-icon"></i>
        </div>
        <div class="ug-mock-stat-card ug-mock-stat-draft">
          <div class="ug-mock-stat-value">Draft</div>
          <div class="ug-mock-stat-label">Status</div>
          <div class="ug-mock-stat-sub">Work log status</div>
          <i class="pi pi-pencil ug-mock-stat-icon"></i>
        </div>
      </div>
    </div>

    <!-- Status flow -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-arrow-right-arrow-left"></i><span>Work Log Status Flow</span></div>
      <div class="ug-status-flow">
        <div class="ug-status-step ug-draft">
          <div class="ug-status-dot"></div>
          <div class="ug-status-label">Draft</div>
          <div class="ug-status-desc">Saved but not yet submitted. You can still add, edit, or delete entries freely.</div>
        </div>
        <div class="ug-status-arrow"><i class="pi pi-arrow-right"></i></div>
        <div class="ug-status-step ug-submitted">
          <div class="ug-status-dot"></div>
          <div class="ug-status-label">Submitted</div>
          <div class="ug-status-desc">Locked for editing. A <i class="pi pi-lock" style="font-size:0.75rem"></i> icon appears next to the title. Awaiting PM or Admin review.</div>
        </div>
        <div class="ug-status-arrow"><i class="pi pi-arrow-right"></i></div>
        <div class="ug-status-step ug-approved">
          <div class="ug-status-dot"></div>
          <div class="ug-status-label">Approved</div>
          <div class="ug-status-desc">Confirmed by your PM or Admin. Process complete.</div>
        </div>
      </div>
    </div>

    <!-- Two ways to add entries -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-plus-circle"></i><span>Two Ways to Add Entries</span></div>
      <!-- CSS mockup: toolbar buttons -->
      <div class="ug-mock-toolbar">
        <div class="ug-mock-btn ug-mock-btn-primary"><i class="pi pi-plus"></i> Add Entries</div>
        <div class="ug-mock-btn ug-mock-btn-secondary"><i class="pi pi-calendar"></i> View Calendar</div>
        <div class="ug-mock-btn ug-mock-btn-success"><i class="pi pi-file-excel"></i> Export Excel</div>
        <div class="ug-mock-btn ug-mock-btn-secondary"><i class="pi pi-chart-bar"></i> Summary</div>
        <div class="ug-mock-btn ug-mock-btn-secondary"><i class="pi pi-question-circle"></i> Guide</div>
        <div class="ug-mock-toolbar-spacer"></div>
        <div class="ug-mock-btn ug-mock-btn-danger"><i class="pi pi-check-circle"></i> Submit</div>
      </div>
      <div class="ug-steps">
        <div class="ug-step">
          <div class="ug-step-num">1</div>
          <div class="ug-step-body">
            <div class="ug-step-title"><i class="pi pi-plus" style="color:var(--primary-color);margin-right:0.25rem"></i> Add Entries Button (Top Bar)</div>
            <div class="ug-step-desc">Opens the <strong>Add Multiple Entries</strong> dialog. Use this to add one or more entries at once, or to log leave. Choose an entry type at the top of the dialog:
              <ul class="ug-field-list">
                <li><strong>Regular</strong> — Select multiple dates, pick a project &amp; task, add description and hours for each entry. Click <em>"Add Another Entry"</em> to add more rows in the same dialog.</li>
                <li><strong>Holiday / Casual / Lieu</strong> — Pick a single date. Project and task are auto-filled. Hours default to 8h.</li>
                <li><strong>Annual Leave</strong> — Pick a start and end date range. All weekdays in that range are logged at 8h automatically.</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="ug-step">
          <div class="ug-step-num">2</div>
          <div class="ug-step-body">
            <div class="ug-step-title"><i class="pi pi-plus" style="color:var(--color-success);margin-right:0.25rem"></i> Green + Button (Table Header)</div>
            <div class="ug-step-desc">Adds a <strong>single blank row</strong> directly into the table for quick inline entry. Fill in each cell: <strong>Project</strong>, <strong>Type of Task</strong>, <strong>Description</strong>, <strong>Date</strong>, and <strong>Hours / Minutes</strong>.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Inline editing -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-pencil"></i><span>Editing Entries Inline</span></div>
      <div class="ug-step-desc">Every cell in the table is editable while the timesheet is in <strong>Draft</strong> status:</div>
      <!-- CSS mockup: table -->
      <div class="ug-mock-table">
        <div class="ug-mock-thead">
          <div class="ug-mock-th ug-mock-th-num"><i class="pi pi-plus" style="font-size:0.6rem;color:var(--color-success)"></i></div>
          <div class="ug-mock-th">PROJECT</div>
          <div class="ug-mock-th">TYPE OF TASK</div>
          <div class="ug-mock-th">DESCRIPTION</div>
          <div class="ug-mock-th ug-mock-th-sm">DATE</div>
          <div class="ug-mock-th ug-mock-th-sm">H / M</div>
          <div class="ug-mock-th ug-mock-th-xs"></div>
        </div>
        <div class="ug-mock-tbody">
          <div class="ug-mock-tr">
            <div class="ug-mock-td ug-mock-td-num">1</div>
            <div class="ug-mock-td"><span class="ug-mock-select">APEX Portal <i class="pi pi-chevron-down"></i></span></div>
            <div class="ug-mock-td"><span class="ug-mock-select">Development <i class="pi pi-chevron-down"></i></span></div>
            <div class="ug-mock-td"><span class="ug-mock-input">API integration</span></div>
            <div class="ug-mock-td ug-mock-td-sm"><span class="ug-mock-input">03/20/2026</span></div>
            <div class="ug-mock-td ug-mock-td-sm"><span class="ug-mock-hm"><span>8</span><span class="ug-mock-hm-sep">h</span><span>0</span><span class="ug-mock-hm-sep">m</span></span></div>
            <div class="ug-mock-td ug-mock-td-xs"><i class="pi pi-trash" style="color:var(--color-danger);font-size:0.65rem"></i></div>
          </div>
          <div class="ug-mock-tr ug-mock-tr-editing">
            <div class="ug-mock-td ug-mock-td-num">2</div>
            <div class="ug-mock-td"><span class="ug-mock-select">HR System <i class="pi pi-chevron-down"></i></span></div>
            <div class="ug-mock-td"><span class="ug-mock-select">Testing <i class="pi pi-chevron-down"></i></span></div>
            <div class="ug-mock-td"><span class="ug-mock-input ug-mock-input-active">Unit tests</span></div>
            <div class="ug-mock-td ug-mock-td-sm"><span class="ug-mock-input">03/21/2026</span></div>
            <div class="ug-mock-td ug-mock-td-sm"><span class="ug-mock-hm"><span>4</span><span class="ug-mock-hm-sep">h</span><span>30</span><span class="ug-mock-hm-sep">m</span></span></div>
            <div class="ug-mock-td ug-mock-td-xs"><i class="pi pi-trash" style="color:var(--color-danger);font-size:0.65rem"></i></div>
          </div>
        </div>
        <div class="ug-mock-table-label">Editing row 2 — highlighted with accent border</div>
      </div>
      <div class="ug-steps" style="margin-top:var(--spacing-sm)">
        <div class="ug-step">
          <div class="ug-step-num"><i class="pi pi-search" style="font-size:0.7rem"></i></div>
          <div class="ug-step-body">
            <div class="ug-step-title">Table Columns</div>
            <div class="ug-step-desc">
              <ul class="ug-field-list">
                <li><strong>Project</strong> — Dropdown with search filter. Only projects allocated to you for the selected month appear.</li>
                <li><strong>Type of Task</strong> — Dropdown filtered by the selected project's available tasks.</li>
                <li><strong>Description</strong> — Free-text input. Describe the work performed.</li>
                <li><strong>Date</strong> — Date picker restricted to the selected month only.</li>
                <li><strong>Hours (H) / Minutes (M)</strong> — Separate fields. Hours: 0–24, Minutes: 0–59. Max <strong>24 h total</strong> per calendar day across all entries.</li>
                <li><strong>Actions</strong> — <i class="pi pi-trash" style="color:var(--color-danger);font-size:0.8rem"></i> Delete button to remove an entry.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="ug-note"><i class="pi pi-info-circle"></i><span>Editing any cell highlights the row and makes the <strong>Save</strong> button appear automatically — no need to hunt for it.</span></div>
    </div>

    <!-- Save & Submit -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-save"></i><span>Saving &amp; Submitting</span></div>
      <div class="ug-steps">
        <div class="ug-step">
          <div class="ug-step-num"><i class="pi pi-save" style="font-size:0.7rem"></i></div>
          <div class="ug-step-body">
            <div class="ug-step-title">Save</div>
            <div class="ug-step-desc">Appears when you have unsaved changes. Saves all entries — timesheet stays in <em>Draft</em> status so you can keep editing.</div>
          </div>
        </div>
        <div class="ug-step">
          <div class="ug-step-num"><i class="pi pi-check-circle" style="font-size:0.7rem"></i></div>
          <div class="ug-step-body">
            <div class="ug-step-title">Submit All Timesheets</div>
            <div class="ug-step-desc">When all hours are logged, click <strong>Submit All Timesheets</strong>. A confirmation dialog will appear with a warning. <span class="ug-warn-pill"><i class="pi pi-exclamation-triangle"></i> This locks the timesheet — no further edits are possible.</span></div>
          </div>
        </div>
        <div class="ug-step">
          <div class="ug-step-num"><i class="pi pi-unlock" style="font-size:0.7rem"></i></div>
          <div class="ug-step-body">
            <div class="ug-step-title">Reopen</div>
            <div class="ug-step-desc">If you need to make changes after submitting, an Admin or PM can click <strong>Reopen</strong> to revert the timesheet back to Draft (only if not yet approved).</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Week structure -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-calendar"></i><span>Week Structure (Summary View)</span></div>
      <div class="ug-week-grid">
        <div class="ug-week-card"><span class="ug-week-label">Week 1</span><span class="ug-week-days">Days 1 – 7</span></div>
        <div class="ug-week-card"><span class="ug-week-label">Week 2</span><span class="ug-week-days">Days 8 – 14</span></div>
        <div class="ug-week-card"><span class="ug-week-label">Week 3</span><span class="ug-week-days">Days 15 – 21</span></div>
        <div class="ug-week-card"><span class="ug-week-label">Week 4</span><span class="ug-week-days">Days 22 – 28</span></div>
        <div class="ug-week-card"><span class="ug-week-label">Week 5</span><span class="ug-week-days">Days 29 – 31</span></div>
      </div>
      <div class="ug-note"><i class="pi pi-info-circle"></i><span>Click <strong>Work Log Summary</strong> to see hours grouped by project per week. You can also <strong>Export Excel</strong> from the summary dialog.</span></div>
    </div>

    <!-- Leave types -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-sun"></i><span>Leave Types (via Add Entries Dialog)</span></div>
      <div class="ug-step-desc" style="margin-bottom:var(--spacing-sm)">Click <strong>Add Entries</strong> and select the leave type from the radio buttons at the top of the dialog. Project and task are filled automatically.</div>
      <!-- CSS mockup: entry type selector -->
      <div class="ug-mock-entry-types">
        <div class="ug-mock-radio ug-mock-radio-active"><span class="ug-mock-radio-dot"></span> Regular</div>
        <div class="ug-mock-radio"><span class="ug-mock-radio-dot"></span> Holiday</div>
        <div class="ug-mock-radio"><span class="ug-mock-radio-dot"></span> Annual</div>
        <div class="ug-mock-radio"><span class="ug-mock-radio-dot"></span> Casual</div>
        <div class="ug-mock-radio"><span class="ug-mock-radio-dot"></span> Lieu</div>
      </div>
      <div class="ug-leave-grid">
        <div class="ug-leave-card ug-leave-holiday"><i class="pi pi-star"></i><span class="ug-leave-name">Public Holiday</span><span class="ug-leave-desc">Single date. 8h auto-filled. Add a description (e.g. holiday name).</span></div>
        <div class="ug-leave-card ug-leave-annual"><i class="pi pi-umbrella"></i><span class="ug-leave-name">Annual Leave</span><span class="ug-leave-desc">Date range (Start → End). 8h per weekday, auto-generated.</span></div>
        <div class="ug-leave-card ug-leave-casual"><i class="pi pi-user-minus"></i><span class="ug-leave-name">Casual Leave</span><span class="ug-leave-desc">Single date. For unplanned or short-notice days off.</span></div>
        <div class="ug-leave-card ug-leave-lieu"><i class="pi pi-clock"></i><span class="ug-leave-name">Lieu Leave</span><span class="ug-leave-desc">Single date. Time off earned from overtime or weekend work.</span></div>
      </div>
    </div>

    <!-- Toolbar buttons -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-wrench"></i><span>Toolbar Buttons</span></div>
      <!-- CSS mockup: full calendar (March 2026 — starts Sunday) -->
      <div class="ug-mock-calendar">
        <div class="ug-mock-cal-header">
          <i class="pi pi-calendar"></i>
          <span>March 2026</span>
          <span class="ug-mock-cal-hint">Click a day to add entry</span>
        </div>
        <div class="ug-mock-cal-legend">
          <span class="ug-mock-legend-pill ug-mock-legend-red"><i class="pi pi-circle"></i> Not Filled</span>
          <span class="ug-mock-legend-pill ug-mock-legend-amber"><i class="pi pi-clock"></i> &lt;8h</span>
          <span class="ug-mock-legend-pill ug-mock-legend-green"><i class="pi pi-check"></i> ≥8h</span>
        </div>
        <div class="ug-mock-cal-weekdays">
          <span>Sun</span><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span>
        </div>
        <div class="ug-mock-cal-grid">
          <!-- Week 1: March 1 = Sunday -->
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">1</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">2</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">3</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">4</span><span class="ug-mock-cell-hrs">9h</span></span>
          <span class="ug-mock-cell ug-mock-cell-amber"><span class="ug-mock-cell-num">5</span><span class="ug-mock-cell-hrs">4h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">6</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">7</span></span>
          <!-- Week 2 -->
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">8</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">9</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">10</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">11</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">12</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">13</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">14</span></span>
          <!-- Week 3 -->
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">15</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">16</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-amber"><span class="ug-mock-cell-num">17</span><span class="ug-mock-cell-hrs">6h</span></span>
          <span class="ug-mock-cell ug-mock-cell-green"><span class="ug-mock-cell-num">18</span><span class="ug-mock-cell-hrs">8h</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">19</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">20</span></span>
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">21</span></span>
          <!-- Week 4 -->
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">22</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">23</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">24</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">25</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">26</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">27</span></span>
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">28</span></span>
          <!-- Week 5 -->
          <span class="ug-mock-cell ug-mock-cell-wknd"><span class="ug-mock-cell-num">29</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">30</span></span>
          <span class="ug-mock-cell ug-mock-cell-red"><span class="ug-mock-cell-num">31</span></span>
        </div>
      </div>
      <div class="ug-tools-grid">
        <div class="ug-tool-card"><i class="pi pi-plus"></i><div class="ug-tool-title">Add Entries</div><div class="ug-tool-desc">Opens the Add Multiple Entries dialog. Log regular work or leave with bulk date selection.</div></div>
        <div class="ug-tool-card"><i class="pi pi-calendar"></i><div class="ug-tool-title">View Calendar</div><div class="ug-tool-desc">Month view with colour-coded days — <span class="ug-chip ug-chip-ok">≥8h</span> <span class="ug-chip ug-chip-warn">&lt;8h</span> <span class="ug-chip ug-chip-danger">not filled</span>. Click a day to add an entry for that date.</div></div>
        <div class="ug-tool-card"><i class="pi pi-file-excel"></i><div class="ug-tool-title">Export Excel</div><div class="ug-tool-desc">Download the full work log to Excel, grouped by week with subtotals and a grand total row.</div></div>
        <div class="ug-tool-card"><i class="pi pi-chart-bar"></i><div class="ug-tool-title">Work Log Summary</div><div class="ug-tool-desc">Project-by-week breakdown table. Also has its own Export Excel button inside the dialog.</div></div>
      </div>
    </div>

    <!-- Rules -->
    <div class="ug-section">
      <div class="ug-section-header"><i class="pi pi-shield"></i><span>Rules &amp; Important Notes</span></div>
      <div class="ug-rules">
        <div class="ug-rule ug-rule-warn"><i class="pi pi-exclamation-circle"></i><span>You <strong>cannot edit</strong> a timesheet once submitted. Ask your Admin or PM to click <strong>Reopen</strong>.</span></div>
        <div class="ug-rule ug-rule-warn"><i class="pi pi-exclamation-circle"></i><span>You <strong>must submit</strong> the previous month's work log before saving entries for the current month.</span></div>
        <div class="ug-rule ug-rule-warn"><i class="pi pi-exclamation-circle"></i><span>Maximum <strong>24 hours per day</strong> total across all entries for the same date.</span></div>
        <div class="ug-rule ug-rule-ok"><i class="pi pi-check-circle"></i><span>Only projects <strong>allocated to you</strong> for the selected month appear in the Project dropdown.</span></div>
        <div class="ug-rule ug-rule-ok"><i class="pi pi-check-circle"></i><span>The <strong>Save</strong> button appears automatically as soon as you add or edit any row.</span></div>
        <div class="ug-rule ug-rule-ok"><i class="pi pi-check-circle"></i><span>Use the <strong>View Calendar</strong> to quickly spot days with missing or insufficient hours.</span></div>
      </div>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="showUserGuide = false" severity="secondary" />
  </ng-template>
</p-dialog>
